import { Injectable } from '@angular/core';
import sessionStorageUtility from '../common/utils/sessionStorage';
import { Menu } from '../shared/entities/Menu';
import { environment } from '../../environments/environment';
import { HttpService } from './http.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class SideMenuFileService {
    menuList: Menu[] = [];

    constructor(
        private httpService: HttpService,
        private router: Router
    ) {}

    getSideMenuFileJson(): Promise<Menu[]> {
        if (!sessionStorageUtility.getSideMenuJson()) {
            return new Promise((resolve, reject) => {
                this.readSideMenuJsonFile()
                    .then((response: Menu[]) => {
                        resolve(response);
                    })
                    .catch((errorMsg: string) => {
                        reject(errorMsg);
                    });
            });
        } else {
            return new Promise(resolve => {
                const sideMenu = sessionStorageUtility.getSideMenuJson();
                resolve(sideMenu);
            });
        }
    }

    private readSideMenuJsonFile(): Promise<Menu[]> {
        return new Promise((resolve, reject) => {
            const sideMenuFileUrl = `${environment.fileUrl}masteradmin_side_menu.json`;
            this.httpService
                .get(sideMenuFileUrl)
                .then((response: any) => {
                    const filteredSideMenu = this.filterSideMenu(response['SidebarMenu'][0]);
                    sessionStorageUtility.setSideMenuJson(filteredSideMenu);
                    resolve(filteredSideMenu);
                })
                .catch(() => {
                    reject('Requested Resource file for the sidemenu is not present');
                });
        });
    }

    private filterSideMenu(menuJson: Menu[]) {
        const enableMenu = menuJson
            .filter((parent: Menu) => parent.enable) // Filter out disabled parents
            .map((parent: Menu) => {
                if (parent.children && parent.children.length > 0) {
                    const filteredChildren = parent.children?.filter(child => child.enable) || [];
                    if (filteredChildren.length > 0) {
                        return {
                            ...parent,
                            children: filteredChildren,
                        };
                    }
                }
                return {
                    ...parent,
                };
            })
            .filter(Boolean);
        return enableMenu;
        // return this.showMenuBasedOnRoles(enableMenu);
    }

    readSideMenuFileAndRoute(isReloadPage = false) {
        this.getSideMenuFileJson().then((response: Menu[]) => {
            this.menuList = response;
            if (this.menuList && this.menuList.length > 0) {
                const firstMenu = this.menuList[0];
                const firstMenuChild = firstMenu?.children?.[0];
                if (firstMenuChild?.url_path) {
                    this.router.navigate([firstMenuChild.url_path]).then(() => {
                        if (isReloadPage) {
                            window.history.replaceState({}, '', firstMenuChild.url_path);
                            location.reload();
                        }
                    });
                } else {
                    this.router.navigate([this.menuList[0].url_path]).then(() => {
                        if (isReloadPage) {
                            window.history.replaceState({}, '', this.menuList[0].url_path);
                            location.reload();
                        }
                    });
                }
            }
        });
    }
}
